(function(window, document){
  'use strict';

  var PS = window.PS || (window.PS = {});
  function q(sel, ctx){ return (ctx || document).querySelector(sel); }
  function trim(val){ return String(val == null ? '' : val).replace(/^\s+|\s+$/g, ''); }
  function hasValue(val){ return trim(val) !== ''; }
  function show(el){ if (el) el.hidden = false; }
  function hide(el){ if (el) el.hidden = true; }
  function setText(el, text){ if (el) el.textContent = text || ''; }
  function setHtml(el, html){ if (el) el.innerHTML = html || ''; }
  var restoreRunTokens = {};
  var saveCartStates = [];

  function escapeHtml(val){
    return String(val == null ? '' : val)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatPaintSummaryCodeHtml(val){
    return escapeHtml(val).replace(/([\/\-,.])/g, '$1<wbr>').replace(/\(/g, '<wbr>(');
  }

  function createCustomEvent(name, detail){
    var evt = null;
    if (!name) return null;
    try {
      if (typeof window.CustomEvent === 'function') return new CustomEvent(name, { detail: detail });
    } catch (_e) {}
    try {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(name, false, false, detail);
      return evt;
    } catch (_e2) {}
    return null;
  }

  function dispatchDocumentEvent(name, detail){
    var evt = createCustomEvent(name, detail || {});
    if (!evt) return;
    try {
      document.dispatchEvent(evt);
    } catch (_e) {}
  }

  function addClass(el, className){
    var current = '';

    if (!el || !className) return;
    current = ' ' + trim(el.className || '') + ' ';
    if (current.indexOf(' ' + className + ' ') !== -1) return;
    el.className = trim(current + className);
  }

  function removeClass(el, className){
    var current = '';
    var pattern = null;

    if (!el || !className) return;
    current = trim(el.className || '');
    if (!current) return;
    pattern = new RegExp('(^|\\s)' + className + '(?=\\s|$)', 'g');
    el.className = trim(current.replace(pattern, ' ').replace(/\s{2,}/g, ' '));
  }

  function closestTag(el, tagName){
    var current = el;
    var target = String(tagName || '').toUpperCase();

    while (current) {
      if (current.tagName && String(current.tagName).toUpperCase() === target) return current;
      current = current.parentNode;
    }
    return null;
  }

  function onReady(cb){
    if (!cb) return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cb);
    else cb();
  }

  function getRoutes(){
    return window.routes || {};
  }

  function getCartBaseUrl(){
    var routes = getRoutes();
    if (routes && routes.cart_url) return String(routes.cart_url).replace(/\/+$/, '');
    return '/cart';
  }

  function getCartJsUrl(){
    return getCartBaseUrl() + '.js';
  }

  function getCartClearUrl(){
    return getCartBaseUrl() + '/clear.js';
  }

  function getCartUpdateUrl(){
    var routes = getRoutes();
    if (routes && routes.cart_update_url) return routes.cart_update_url;
    return getCartBaseUrl() + '/update.js';
  }

  function getCartAddUrl(){
    var routes = getRoutes();
    if (routes && routes.cart_add_url) return routes.cart_add_url;
    return getCartBaseUrl() + '/add.js';
  }

  function getThemeBaseUrl(){
    var configured = '';
    var normalized = '';

    try {
      configured = trim(window.paintscratchTheme && window.paintscratchTheme.psUrl);
    } catch (_e) {
      configured = '';
    }

    if (configured) {
      normalized = configured.replace(/\/+$/, '');
      return normalized;
    }

    return 'https://hub.paintscratch.com';
  }

  function getRestoreBaseUrl(){
    return 'https://hub.paintscratch.com';
  }

  function getSaveEndpoint(){
    return getThemeBaseUrl() + '/api/shopify/save-cart';
  }

  function getLookupEndpoint(token){
    return getRestoreBaseUrl() + '/api/shopify/save-cart/' + encodeURIComponent(trim(token));
  }

  function getQueryParam(name){
    var search = String(window.location && window.location.search ? window.location.search : '');
    var parts = [];
    var i = 0;
    var pair = '';
    var item = null;
    var key = '';
    var value = '';

    if (!search) return '';
    search = search.replace(/^\?/, '');
    if (!search) return '';
    parts = search.split('&');
    for (i = 0; i < parts.length; i++) {
      pair = parts[i];
      if (!pair) continue;
      item = pair.split('=');
      key = decodeURIComponent((item[0] || '').replace(/\+/g, ' '));
      if (key !== name) continue;
      value = item.length > 1 ? item.slice(1).join('=') : '';
      return decodeURIComponent(String(value).replace(/\+/g, ' '));
    }
    return '';
  }

  function buildUrlWithoutParam(name){
    var search = String(window.location && window.location.search ? window.location.search : '');
    var hash = String(window.location && window.location.hash ? window.location.hash : '');
    var path = String(window.location && window.location.pathname ? window.location.pathname : '/');
    var parts = [];
    var kept = [];
    var i = 0;
    var pair = '';
    var item = null;
    var key = '';

    if (search) {
      search = search.replace(/^\?/, '');
      if (search) {
        parts = search.split('&');
        for (i = 0; i < parts.length; i++) {
          pair = parts[i];
          if (!pair) continue;
          item = pair.split('=');
          key = decodeURIComponent((item[0] || '').replace(/\+/g, ' '));
          if (key === name) continue;
          kept.push(pair);
        }
      }
    }

    if (kept.length) return path + '?' + kept.join('&') + hash;
    return path + hash;
  }

  function removeRestoreParamFromUrl(){
    var cleanUrl = buildUrlWithoutParam('ps_saved_cart');

    try {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, document.title, cleanUrl);
        return;
      }
    } catch (_e) {}
  }

  function parseResponse(text){
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (_e) {
      return null;
    }
  }

  function requestJson(method, url, data, cb){
    var xhr = new XMLHttpRequest();

    xhr.open(method, url, true);
    xhr.timeout = 30000;
    xhr.setRequestHeader('Accept', 'application/json');
    if (method !== 'GET') xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function(){
      if (xhr.readyState !== 4) return;
      cb(xhr.status, parseResponse(xhr.responseText || ''), xhr);
    };
    xhr.onerror = function(){
      cb(0, null, xhr);
    };
    xhr.ontimeout = function(){
      cb(0, null, xhr);
    };
    xhr.send(data ? JSON.stringify(data) : null);
  }

  function getJson(url, cb){
    requestJson('GET', url, null, cb);
  }

  function postJson(url, data, cb){
    requestJson('POST', url, data, cb);
  }

  function cloneProperties(properties){
    var out = {};
    var key = '';
    var value = null;

    if (!properties || typeof properties !== 'object') return out;
    for (key in properties) {
      if (!properties.hasOwnProperty(key)) continue;
      value = properties[key];
      if (typeof value === 'undefined') continue;
      out[key] = value;
    }
    return out;
  }

  function getItemProperty(properties, key){
    if (!properties || typeof properties !== 'object') return '';
    if (!properties.hasOwnProperty(key)) return '';
    if (properties[key] == null) return '';
    return trim(properties[key]);
  }

  function isKnownCustomColorProduct(item){
    var handle = trim(item && item.handle).toLowerCase();
    var handles = window.paintscratchTheme && window.paintscratchTheme.psColorProductBaseMap;
    return handle === 'custom-hand-matched-paint' || handle === 'custom-hand-matched-tricoat-paint' || handle === 'pen-dev' || !!(handle && handles && handles[handle]);
  }

  function isCustomColorCartItem(item){
    var properties = item && item.properties ? item.properties : {};
    return isKnownCustomColorProduct(item) && (hasValue(getItemProperty(properties, 'Color Name')) || hasValue(getItemProperty(properties, 'Color Code')));
  }

  function cloneCartProperties(item){
    var out = cloneProperties(item && item.properties);
    var reserved = ['Make', 'Color Name', 'Color Code', 'Year', 'Model', '_isGuaranteed', 'Factory Code', '_ps_make_slug', '_ps_color_slug', '_ps_product_slug', 'Paint Formula'];
    var i = 0;
    if (!hasValue(item && item.handle) && !hasValue(item && item.product_type)) return out;
    if (isKnownCustomColorProduct(item)) return out;
    for (i = 0; i < reserved.length; i += 1) {
      delete out[reserved[i]];
    }
    return out;
  }

  function getItemImageUrl(item){
    var image = '';

    if (item && item.featured_image && item.featured_image.url) {
      image = trim(item.featured_image.url);
      if (image) return image;
    }

    if (item && typeof item.image === 'string') {
      image = trim(item.image);
      if (image) return image;
    }

    if (item && item.image && item.image.url) {
      image = trim(item.image.url);
      if (image) return image;
    }

    return '';
  }

  function getSelectedSizeToken(item){
    var options = item && item.options_with_values ? item.options_with_values : [];
    var i = 0;
    var option = null;
    var optionName = '';
    var optionValue = '';

    for (i = 0; i < options.length; i++) {
      option = options[i];
      if (!option || typeof option !== 'object') continue;
      optionName = trim(option.name).toLowerCase();
      optionValue = trim(option.value);
      if (optionName === 'size' && optionValue) return optionValue;
    }

    return getItemProperty(item && item.properties, 'Size');
  }

  function applySizeTokenTitle(title, selectedSize){
    var text = trim(title);
    var sizeToken = '';

    if (!text) return '';
    if (!selectedSize) return text;

    sizeToken = '(' + selectedSize + ')';
    text = text.replace(/\(1 Gallon\)/g, sizeToken);
    text = text.replace(/\(1 Quart\)/g, sizeToken);
    text = text.replace(/\(1 Pint\)/g, sizeToken);
    text = text.replace(/\(Gallon\)/g, sizeToken);
    text = text.replace(/\(Quart\)/g, sizeToken);
    text = text.replace(/\(Pint\)/g, sizeToken);
    return text;
  }

  function getDisplayTitle(item, productTitle){
    var text = trim(productTitle || '');
    var make = '';
    var colorName = '';
    var colorCode = '';
    var replacementParts = [];
    var replacement = '';
    var selectedSize = '';

    if (!text) return '';

    if (isCustomColorCartItem(item) && text.indexOf('Custom Color') !== -1) {
      make = getItemProperty(item && item.properties, 'Make');
      colorName = getItemProperty(item && item.properties, 'Color Name');
      colorCode = getItemProperty(item && item.properties, 'Color Code');

      if (make) replacementParts.push(make);
      if (colorName) replacementParts.push(colorName);
      if (colorCode) replacementParts.push(colorCode);

      replacement = trim(replacementParts.join(' '));
      if (replacement) text = text.replace(/Custom Color/g, replacement);
    }

    selectedSize = getSelectedSizeToken(item);
    return applySizeTokenTitle(text, selectedSize);
  }

  function normalizeCents(value){
    var parsed = 0;
    var text = '';

    if (typeof value === 'number' && isFinite(value)) {
      return Math.round(value);
    }

    if (typeof value !== 'string') return 0;
    text = trim(value);
    if (!text) return 0;
    if (!/^-?\d+(\.\d+)?$/.test(text)) return 0;

    parsed = parseFloat(text);
    if (!isFinite(parsed)) return 0;
    return Math.round(parsed);
  }

  function normalizeCartItem(item){
    var id = 0;
    var variantId = 0;
    var quantity = 1;
    var unitPrice = 0;
    var linePrice = 0;
    var productTitle = '';
    var out = {};

    if (!item || typeof item !== 'object') return null;
    id = item.id || item.variant_id || 0;
    if (!id) return null;
    variantId = item.variant_id || id;
    quantity = parseInt(item.quantity, 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    if (item.final_price != null && item.final_price !== '') unitPrice = normalizeCents(item.final_price);
    else if (item.price != null && item.price !== '') unitPrice = normalizeCents(item.price);
    else unitPrice = 0;

    if (item.final_line_price != null && item.final_line_price !== '') linePrice = normalizeCents(item.final_line_price);
    else if (item.line_price != null && item.line_price !== '') linePrice = normalizeCents(item.line_price);
    else linePrice = unitPrice * quantity;

    if (!isFinite(unitPrice)) unitPrice = 0;
    if (!isFinite(linePrice)) linePrice = 0;
    productTitle = item.product_title || item.title || '';

    out.id = id;
    out.variant_id = variantId;
    out.quantity = quantity;
    if (item.selling_plan != null && item.selling_plan !== '') out.selling_plan = item.selling_plan;
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) {
      out.selling_plan = item.selling_plan_allocation.selling_plan.id;
    }
    out.product_title = productTitle;
    out.handle = item.handle || '';
    out.product_type = item.product_type || '';
    out.display_title = getDisplayTitle(item, productTitle);
    out.image = getItemImageUrl(item);
    out.unit_price = unitPrice;
    out.line_price = linePrice;
    out.properties = cloneCartProperties(item);
    return out;
  }

  function normalizeCartResponse(cart){
    var items = [];
    var i = 0;
    var normalizedItem = null;
    var out = {};

    if (!cart || typeof cart !== 'object') return null;
    if (cart.items && cart.items.length) {
      for (i = 0; i < cart.items.length; i++) {
        normalizedItem = normalizeCartItem(cart.items[i]);
        if (normalizedItem) items.push(normalizedItem);
      }
    }

    out.token = cart.token || '';
    out.note = cart.note || '';
    out.attributes = cart.attributes && typeof cart.attributes === 'object' ? cloneProperties(cart.attributes) : {};
    out.currency = cart.currency || '';
    out.item_count = cart.item_count || items.length;
    out.total_price = cart.total_price || 0;
    out.items = items;
    return out;
  }

  function getCartItemCount(cart){
    var count = parseInt(cart && cart.item_count, 10);
    var items = cart && cart.items ? cart.items : [];
    var i = 0;
    var quantity = 0;

    if (!isNaN(count) && count >= 0) return count;
    count = 0;
    for (i = 0; i < items.length; i++) {
      quantity = parseInt(items[i] && items[i].quantity, 10);
      if (isNaN(quantity) || quantity < 1) quantity = 1;
      count += quantity;
    }
    return count;
  }

  function collectSummaryThumbSources(cart, maxThumbs){
    var out = [];
    var items = cart && cart.items ? cart.items : [];
    var i = 0;
    var image = '';
    var limit = parseInt(maxThumbs, 10);

    for (i = 0; i < items.length; i++) {
      image = trim(items[i] && items[i].image);
      out.push(image);
      if (!isNaN(limit) && limit > 0 && out.length >= limit) return out;
    }
    return out;
  }

  function parseCssNumber(raw, fallback){
    var parsed = parseFloat(trim(raw || ''));
    if (isNaN(parsed)) return fallback;
    return parsed;
  }

  function getSummaryThumbLimit(state, itemCount){
    var gallery = state && state.summaryGalleryEl;
    var galleryStyles = null;
    var galleryWidth = 0;
    var thumbSize = 92;
    var gap = 12;
    var overflowWidth = 84;
    var visibleWithoutOverflow = 0;
    var visibleWithOverflow = 0;
    var slotWidth = 0;
    var maxSlots = 8;

    if (!itemCount || itemCount < 1) return 0;
    if (!gallery) return itemCount > 5 ? 5 : itemCount;

    galleryWidth = gallery.clientWidth || gallery.offsetWidth || 0;
    if (galleryWidth < 1) return itemCount > 5 ? 5 : itemCount;

    if (window.getComputedStyle) {
      galleryStyles = window.getComputedStyle(gallery);
      thumbSize = parseCssNumber(galleryStyles && galleryStyles.getPropertyValue('--ps-save-cart-thumb-size'), thumbSize);
      gap = parseCssNumber(galleryStyles && (galleryStyles.columnGap || galleryStyles.gap), gap);
      overflowWidth = parseCssNumber(galleryStyles && galleryStyles.getPropertyValue('--ps-save-cart-overflow-min-width'), overflowWidth);
    }

    if (thumbSize < 1) thumbSize = 92;
    if (gap < 0) gap = 0;
    if (overflowWidth < 0) overflowWidth = 84;

    slotWidth = thumbSize + gap;
    if (slotWidth < 1) slotWidth = 104;

    visibleWithoutOverflow = Math.floor((galleryWidth + gap) / slotWidth);
    if (visibleWithoutOverflow < 1) visibleWithoutOverflow = 1;
    if (visibleWithoutOverflow > maxSlots) visibleWithoutOverflow = maxSlots;
    if (itemCount <= visibleWithoutOverflow) return itemCount;

    visibleWithOverflow = Math.floor((galleryWidth - overflowWidth + gap) / slotWidth);
    if (visibleWithOverflow < 1) visibleWithOverflow = 1;
    if (visibleWithOverflow > maxSlots) visibleWithOverflow = maxSlots;
    return visibleWithOverflow;
  }

  function buildSummaryThumb(image){
    var thumbEl = document.createElement('span');
    var imageEl = null;
    var placeholderEl = null;
    var src = trim(image);

    thumbEl.className = 'ps-save-cart__summary-icon';
    if (src) {
      imageEl = document.createElement('img');
      imageEl.className = 'ps-save-cart__summary-image';
      imageEl.alt = '';
      imageEl.src = src;
      thumbEl.appendChild(imageEl);
      return thumbEl;
    }

    placeholderEl = document.createElement('span');
    placeholderEl.className = 'ps-save-cart__summary-image-placeholder';
    placeholderEl.setAttribute('aria-hidden', 'true');
    thumbEl.appendChild(placeholderEl);
    return thumbEl;
  }

  function renderSummaryThumbs(state, thumbSources){
    var thumbsEl = state && state.summaryThumbsEl;
    var i = 0;

    if (!thumbsEl) return;
    while (thumbsEl.firstChild) thumbsEl.removeChild(thumbsEl.firstChild);
    for (i = 0; i < thumbSources.length; i++) {
      thumbsEl.appendChild(buildSummaryThumb(thumbSources[i]));
    }
  }

  function isPaintSummaryItem(item){
    return isCustomColorCartItem(item);
  }

  function buildPaintSummaryIdentity(item){
    var properties = item && item.properties ? item.properties : {};
    var make = trim(getItemProperty(properties, 'Make'));
    var year = trim(getItemProperty(properties, 'Year'));
    var model = trim(getItemProperty(properties, 'Model'));
    var colorName = trim(getItemProperty(properties, 'Color Name'));
    var colorCode = trim(getItemProperty(properties, 'Color Code'));
    var title = trim(item && (item.display_title || item.product_title || item.title));
    var text = '';
    var parsedCode = '';
    var parsedCodeMatch = null;
    var suffixCodeMatch = null;
    var dashSplitPattern = /\s(?:-|\u2013|\u2014)\s/;

    if (colorName || colorCode) {
      return {
        code: colorCode,
        name: colorName,
        make: make,
        year: year,
        model: model,
        key: (colorCode + '|' + colorName + '|' + make + '|' + year + '|' + model).toLowerCase()
      };
    }

    text = title;
    if (!text) return null;

    if (dashSplitPattern.test(text)) text = trim(text.split(dashSplitPattern)[0]);
    text = text.replace(/\b(touch-?up|exact-?match|spray can|paint pen|repair system|complete repair system|beginner-?friendly|kit|bottle|pro)\b.*$/i, '');
    text = trim(text);

    parsedCodeMatch = text.match(/\(([A-Za-z0-9-]+)\)\s*$/);
    if (!colorCode && parsedCodeMatch && parsedCodeMatch[1]) {
      parsedCode = trim(parsedCodeMatch[1]);
      text = trim(text.replace(/\(([A-Za-z0-9-]+)\)\s*$/, ''));
    }

    if (!colorCode) {
      suffixCodeMatch = text.match(/\s([A-Za-z]*\d[A-Za-z0-9-]*)\s*$/);
      if (suffixCodeMatch && suffixCodeMatch[1]) {
        parsedCode = trim(suffixCodeMatch[1]);
        text = trim(text.replace(/\s([A-Za-z]*\d[A-Za-z0-9-]*)\s*$/, ''));
      }
    }

    if (make && text.toLowerCase().indexOf(make.toLowerCase()) === 0) {
      text = trim(text.slice(make.length));
    }

    colorCode = colorCode || parsedCode;

    return {
      code: colorCode,
      name: text,
      make: make,
      year: year,
      model: model,
      key: (colorCode + '|' + text + '|' + make + '|' + year + '|' + model).toLowerCase()
    };
  }

  function buildPaintSummaryVehicleLabel(item){
    var parts = [];
    var make = trim(item && item.make);
    var year = trim(item && item.year);
    var model = trim(item && item.model);

    if (make && year) parts.push(year);
    if (make) parts.push(make);
    if (make && model) parts.push(model);
    return parts.length ? parts.join(' ') : 'COLOR';
  }

  function collectPaintSummaryIdentities(cart){
    var out = [];
    var seen = {};
    var items = cart && cart.items ? cart.items : [];
    var i = 0;
    var identity = null;
    var key = '';

    for (i = 0; i < items.length; i++) {
      if (!isPaintSummaryItem(items[i])) continue;
      identity = buildPaintSummaryIdentity(items[i]);
      if (!identity || (!identity.code && !identity.name)) continue;
      key = identity.key || ((identity.code || '') + '|' + (identity.name || '') + '|' + (identity.make || '')).toLowerCase();
      if (seen[key]) continue;
      seen[key] = true;
      out.push(identity);
    }
    return out;
  }

  function renderPaintSummaryList(state, paintSummaries){
    var html = [];
    var i = 0;
    var item = null;
    var label = '';
    var identity = '';

    if (!state || !state.summaryPaintListEl) return;
    for (i = 0; i < paintSummaries.length; i++) {
      item = paintSummaries[i];
      label = buildPaintSummaryVehicleLabel(item);
      identity = item.code ? formatPaintSummaryCodeHtml(item.code || 'Code unavailable') : '';
      if (item.name) {
        identity = identity ? identity + ' - ' + escapeHtml(item.name) : escapeHtml(item.name);
      }
      html.push(
        '<span class="ps-save-cart__summary-paint-item">' +
          '<span class="ps-save-cart__summary-paint-label">' + escapeHtml(label) + '</span>' +
          '<span class="ps-save-cart__summary-paint-code">' + identity + '</span>' +
        '</span>'
      );
    }
    setHtml(state.summaryPaintListEl, html.join(''));
  }

  function formatMoney(cents, currency){
    var amount = parseInt(cents, 10);
    var value = 0;

    if (isNaN(amount)) amount = 0;
    value = amount / 100;

    try {
      if (window.Intl && Intl.NumberFormat) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format(value);
      }
    } catch (_e) {}

    return '$' + value.toFixed(2);
  }

  function isValidEmail(value){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trim(value));
  }

  function getDefaultSuccessCopy(){
    return 'Check your inbox for your saved cart link. If you do not see it, check Spam or Promotions.';
  }

  function normalizeSuccessCopy(message){
    var text = trim(message);
    var lower = '';

    if (!text) return getDefaultSuccessCopy();
    lower = text.toLowerCase();

    if (lower === 'cart emailed' || lower === 'cart email sent' || lower === 'emailed' || lower === 'email sent') {
      return getDefaultSuccessCopy();
    }

    if (text.length <= 22 && lower.indexOf('email') !== -1) {
      return getDefaultSuccessCopy();
    }

    return text;
  }

  function getDefaultSavedLabel(){
    return 'Cart saved';
  }

  function getSavedEmailFallback(){
    return 'your email address';
  }

  function getPreferredEmail(state){
    var formEmail = trim(state && state.emailEl && state.emailEl.value);
    var customerEmail = trim(state && state.customerEmail);

    if (isValidEmail(formEmail)) return formEmail;
    if (isValidEmail(customerEmail)) return customerEmail;
    if (hasValue(formEmail)) return formEmail;
    return customerEmail;
  }

  function setToggleLabel(state, label){
    var text = hasValue(label) ? String(label) : '';
    if (!state || !state.toggleEl) return;
    if (state.toggleLabelEl) {
      setText(state.toggleLabelEl, text);
      return;
    }
    setText(state.toggleEl, text);
  }

  function clearTooltipDismissTimer(state){
    if (!state || !state.tooltipDismissTimer) return;
    try {
      window.clearTimeout(state.tooltipDismissTimer);
    } catch (_e) {}
    state.tooltipDismissTimer = 0;
  }

  function positionTooltip(state){
    var tooltip = state && state.tooltipEl;
    var viewportWidth = 0;
    var minMargin = 16;
    var rect = null;
    var shift = 0;

    if (!tooltip || tooltip.hidden || !tooltip.getBoundingClientRect) return;
    tooltip.style.marginLeft = '0px';
    rect = tooltip.getBoundingClientRect();
    viewportWidth = window.innerWidth || (document.documentElement && document.documentElement.clientWidth) || 0;
    if (!viewportWidth) return;

    if (rect.left < minMargin) shift = minMargin - rect.left;
    if (rect.right + shift > viewportWidth - minMargin) shift += (viewportWidth - minMargin) - (rect.right + shift);
    if (shift !== 0) tooltip.style.marginLeft = shift + 'px';
  }

  function setTooltipVisibility(state, isVisible){
    if (!state || !state.tooltipEl) return;
    clearTooltipDismissTimer(state);
    if (isVisible) {
      show(state.tooltipEl);
      positionTooltip(state);
      state.tooltipDismissTimer = window.setTimeout(function(){
        if (!state || !state.tooltipEl) return;
        hide(state.tooltipEl);
        state.tooltipDismissTimer = 0;
      }, 10000);
      return;
    }
    hide(state.tooltipEl);
  }

  function dismissTooltip(state){
    clearTooltipDismissTimer(state);
    if (state && state.tooltipEl) hide(state.tooltipEl);
  }

  function setTooltipEmail(state, email){
    if (!state || !state.tooltipEmailEl) return;
    setText(state.tooltipEmailEl, hasValue(email) ? trim(email) : getSavedEmailFallback());
  }

  function applySavedState(state, email, options){
    var savedEmail = hasValue(email) ? trim(email) : '';
    var cfg = options && typeof options === 'object' ? options : {};
    var showTooltipOnSave = cfg.showTooltip !== false;
    if (!state || !state.root) return;

    state.saved = true;
    if (savedEmail) state.savedEmail = savedEmail;
    if (!hasValue(state.savedEmail)) state.savedEmail = getPreferredEmail(state);
    if (!hasValue(state.savedEmail)) state.savedEmail = getSavedEmailFallback();

    state.root.setAttribute('data-ps-save-cart-complete', 'true');
    setToggleLabel(state, getDefaultSavedLabel());
    if (state.toggleEl) state.toggleEl.disabled = true;
    setTooltipEmail(state, state.savedEmail);
    if (showTooltipOnSave) setTooltipVisibility(state, true);
    else setTooltipVisibility(state, false);
  }

  function setStatusElement(el, baseClass, kind, message){
    if (!el) return;
    setText(el, message || '');
    el.className = baseClass;
    if (kind === 'error' && message) {
      el.className += ' ps-save-cart__status--error';
      show(el);
      return;
    }
    if (message) {
      show(el);
      return;
    }
    hide(el);
  }

  function setStatus(state, scope, kind, message){
    if (scope === 'modal') {
      setStatusElement(state.modalStatusEl, 'ps-save-cart__modal-status form__message', kind, message);
      return;
    }
    setStatusElement(state.pageStatusEl, 'ps-save-cart__status form__message', kind, message);
  }

  function setLoading(state, scope, isLoading){
    var button = scope === 'modal' ? state.submitEl : state.toggleEl;
    var label = '';

    if (!button) return;
    if (scope === 'modal') {
      label = button.getAttribute('data-ps-save-cart-label') || 'Email me this cart';
      button.disabled = !!isLoading;
      button.textContent = isLoading ? 'Sending...' : label;
    } else {
      label = state.toggleDefaultLabel || button.getAttribute('data-ps-save-cart-label') || 'Save Cart';
      button.disabled = !!isLoading;
      setToggleLabel(state, isLoading ? 'Saving...' : label);
    }
  }

  function clearEmailError(state){
    if (!state.emailEl) return;
    state.emailEl.className = state.emailEl.className.replace(/\bis-error\b/g, '').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/g, '');
    state.emailEl.removeAttribute('aria-invalid');
    hide(state.emailErrorEl);
  }

  function setEmailError(state, message){
    if (!state.emailEl) return;
    clearEmailError(state);
    state.emailEl.className += ' is-error';
    state.emailEl.setAttribute('aria-invalid', 'true');
    setText(state.emailErrorEl, message || 'Enter a valid email address.');
    show(state.emailErrorEl);
  }

  function updateSummary(state, cart){
    var allThumbSources = collectSummaryThumbSources(cart, 0);
    var items = allThumbSources.length;
    var total = cart && typeof cart.total_price !== 'undefined' ? cart.total_price : 0;
    var currency = cart && cart.currency ? cart.currency : 'USD';
    var thumbLimit = getSummaryThumbLimit(state, items);
    var thumbSources = collectSummaryThumbSources(cart, thumbLimit);
    var thumbOverflow = items > thumbSources.length ? items - thumbSources.length : 0;
    var paintSummaries = collectPaintSummaryIdentities(cart);

    state.summaryCart = cart || null;
    setText(state.summaryCodeEl, 'Total: ' + formatMoney(total, currency));

    if (paintSummaries.length > 0) {
      renderPaintSummaryList(state, paintSummaries);
      show(state.summaryPaintEl);
      removeClass(state.summaryEl, 'ps-save-cart__summary--no-paint');
    } else {
      setHtml(state.summaryPaintListEl, '');
      hide(state.summaryPaintEl);
      addClass(state.summaryEl, 'ps-save-cart__summary--no-paint');
    }

    renderSummaryThumbs(state, thumbSources);
    if (thumbSources.length > 0 || thumbOverflow > 0) show(state.summaryGalleryEl);
    else hide(state.summaryGalleryEl);

    if (state.summaryOverflowEl) {
      if (thumbOverflow > 0) {
        setText(state.summaryOverflowEl, '+' + thumbOverflow + ' more');
        show(state.summaryOverflowEl);
      } else {
        setText(state.summaryOverflowEl, '');
        hide(state.summaryOverflowEl);
      }
    }
  }

  function isModalVisible(el){
    if (!el) return false;
    return el.getAttribute('aria-hidden') === 'false';
  }

  function syncModalBodyClass(state){
    var hasAnyOpen = false;

    hasAnyOpen = isModalVisible(state && state.modalEl) || isModalVisible(state && state.restoreModalEl);
    try {
      if (hasAnyOpen) document.body.classList.add('ps-modal-open');
      else document.body.classList.remove('ps-modal-open');
    } catch (_e) {}
  }

  function getDeviceType(){
    try {
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches && window.matchMedia('(pointer: fine)').matches) return 'desktop';
    } catch (_e) {}
    return 'mobile';
  }

  function normalizeSourcePageType(value, fallback){
    var pageType = trim(value).toLowerCase();
    if (!pageType) pageType = trim(fallback).toLowerCase();
    if (pageType === 'cart_page') pageType = 'cart';
    return pageType;
  }

  function getStatePageType(state){
    var root = state && state.root ? state.root : null;
    var pageType = trim(root && root.getAttribute ? root.getAttribute('data-ps-save-cart-page-type') : '');
    var path = trim(window.location && window.location.pathname ? window.location.pathname : '');

    pageType = normalizeSourcePageType(pageType, '');
    if (pageType) return pageType;

    if (!path || path === '/') return 'index';
    if (/^\/cart(\/|$)/i.test(path)) return 'cart';
    if (/^\/products\//i.test(path)) return 'product';
    if (/^\/collections\//i.test(path)) return 'collection';
    if (/^\/pages\//i.test(path)) return 'page';
    if (/^\/search(\/|$)/i.test(path)) return 'search';
    if (/^\/blogs\//i.test(path)) return 'blog';
    return 'site';
  }

  function getStateSurface(state, fallbackPageType){
    var root = state && state.root ? state.root : null;
    var surface = trim(root && root.getAttribute ? root.getAttribute('data-ps-save-cart-surface') : '').toLowerCase();
    if (surface) return surface;
    return normalizeSourcePageType(fallbackPageType, getStatePageType(state));
  }

  function sortObjectKeys(obj){
    var keys = [];
    var key = '';
    var i = 0;
    var out = {};
    if (!obj || typeof obj !== 'object') return out;
    for (key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      keys.push(key);
    }
    keys.sort();
    for (i = 0; i < keys.length; i++) out[keys[i]] = obj[keys[i]];
    return out;
  }

  function buildCartSignature(cart){
    var items = cart && cart.items ? cart.items : [];
    var parts = [];
    var i = 0;
    var item = null;
    var properties = null;
    var propText = '';
    if (!items.length) return 'empty';
    for (i = 0; i < items.length; i++) {
      item = items[i] || {};
      properties = sortObjectKeys(item.properties || {});
      propText = JSON.stringify(properties);
      parts.push([
        String(item.id || item.variant_id || ''),
        String(item.quantity || 0),
        String(item.selling_plan || ''),
        propText
      ].join('~'));
    }
    parts.sort();
    return parts.join('|');
  }

  function normalizeModalContext(context){
    var out = context && typeof context === 'object' ? context : {};
    var source = trim(out.source).toLowerCase();
    var sourcePageType = normalizeSourcePageType(out.source_page_type, '');
    var sourceSurface = trim(out.source_surface).toLowerCase();

    if (source !== 'exit_intent') source = 'manual';
    if (!sourceSurface) sourceSurface = sourcePageType;
    return {
      source: source,
      variant_id: trim(out.variant_id),
      trigger_type: trim(out.trigger_type),
      offer_id: trim(out.offer_id),
      source_page_type: sourcePageType,
      source_surface: sourceSurface,
      device_type: trim(out.device_type).toLowerCase(),
      winner_reason: trim(out.winner_reason),
      confidence_reasons: trim(out.confidence_reasons),
      cart_signature: trim(out.cart_signature)
    };
  }

  function getActiveContext(state){
    return normalizeModalContext(state && state.activeModalContext);
  }

  function buildEventDetail(state, extra){
    var context = getActiveContext(state);
    var fallbackPageType = getStatePageType(state);
    var fallbackSurface = getStateSurface(state, fallbackPageType);
    var detail = {
      source_page_type: fallbackPageType,
      source_surface: fallbackSurface,
      source: 'manual',
      variant_id: '',
      offer_id: 'cart-save',
      trigger_type: '',
      device_type: getDeviceType(),
      winner_reason: '',
      confidence_reasons: '',
      cart_signature: '',
      cart_token: '',
      item_count: 0,
      total_price: 0,
      currency: ''
    };
    var merged = extra && typeof extra === 'object' ? extra : {};
    var key = '';

    if (state && state.latestCart && typeof state.latestCart === 'object') {
      detail.cart_token = trim(state.latestCart.token);
      detail.item_count = parseInt(state.latestCart.item_count, 10) || 0;
      detail.total_price = parseInt(state.latestCart.total_price, 10) || 0;
      detail.currency = trim(state.latestCart.currency);
      detail.cart_signature = buildCartSignature(state.latestCart);
    }
    if (!detail.item_count && state && state.root) detail.item_count = parseInt(state.root.getAttribute('data-ps-save-cart-count'), 10) || 0;
    if (!detail.total_price && state && state.root) detail.total_price = parseInt(state.root.getAttribute('data-ps-save-cart-total'), 10) || 0;
    if (!detail.currency && state && state.root) detail.currency = trim(state.root.getAttribute('data-ps-save-cart-currency'));

    detail.source = context.source;
    detail.variant_id = context.variant_id;
    detail.offer_id = context.offer_id || detail.offer_id;
    detail.trigger_type = context.trigger_type;
    if (hasValue(context.source_page_type)) detail.source_page_type = normalizeSourcePageType(context.source_page_type, detail.source_page_type);
    if (hasValue(context.source_surface)) detail.source_surface = trim(context.source_surface).toLowerCase();
    if (hasValue(context.device_type)) detail.device_type = trim(context.device_type).toLowerCase();
    if (hasValue(context.winner_reason)) detail.winner_reason = context.winner_reason;
    if (hasValue(context.confidence_reasons)) detail.confidence_reasons = context.confidence_reasons;
    if (hasValue(context.cart_signature)) detail.cart_signature = context.cart_signature;

    for (key in merged) {
      if (!merged.hasOwnProperty(key)) continue;
      detail[key] = merged[key];
    }
    if (!detail.offer_id) detail.offer_id = detail.variant_id || 'cart-save';
    return detail;
  }

  function emitSaveCartEvent(state, name, extra){
    if (!name) return;
    dispatchDocumentEvent(name, buildEventDetail(state, extra));
  }

  function setRestorePageActive(state, isActive){
    if (!state) return;
    if (isActive) {
      addClass(state.cartItemsEl, 'ps-save-cart-restore-active');
      addClass(state.footerEl, 'ps-save-cart-restore-active');
      addClass(document.body, 'ps-save-cart-restore-active');
      addClass(document.documentElement, 'ps-save-cart-restore-active');
      return;
    }

    removeClass(state.cartItemsEl, 'ps-save-cart-restore-active');
    removeClass(state.footerEl, 'ps-save-cart-restore-active');
    removeClass(document.body, 'ps-save-cart-restore-active');
    removeClass(document.documentElement, 'ps-save-cart-restore-active');
  }

  function setModalOpen(state, isOpen){
    if (!state.modalEl) return;

    state.modalEl.style.display = isOpen ? 'flex' : 'none';
    state.modalEl.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    if (state.toggleEl) state.toggleEl.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    syncModalBodyClass(state);
  }

  function setRestoreModalOpen(state, isOpen){
    if (!state || !state.restoreModalEl) return;
    state.restoreModalEl.style.display = isOpen ? 'flex' : 'none';
    state.restoreModalEl.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    syncModalBodyClass(state);
  }

  function setRestoreModalMessage(state, message){
    if (!state || !state.restoreModalMessageEl) return;
    if (state.restoreModalProgressEl) show(state.restoreModalProgressEl);
    hide(state.restoreModalErrorEl);
    hide(state.restoreModalActionsEl);
    setText(state.restoreModalMessageEl, hasValue(message) ? message : 'Restoring your saved cart. Please wait...');
  }

  function setRestoreModalError(state, message){
    if (!state) return;
    hide(state.restoreModalProgressEl);
    if (state.restoreModalErrorEl) {
      setText(state.restoreModalErrorEl, hasValue(message) ? message : 'We could not restore this cart right now. Please use the email link again or request a new one.');
      show(state.restoreModalErrorEl);
    }
    show(state.restoreModalActionsEl);
  }

  function openRestoreModal(state, message){
    setRestoreModalMessage(state, message);
    setRestoreModalOpen(state, true);
  }

  function closeRestoreModal(state){
    setRestoreModalOpen(state, false);
  }

  function openModal(state, context){
    var modalContext = normalizeModalContext(context);
    var focusTarget = null;

    if (!state || !state.modalEl) return;
    state.activeModalContext = modalContext;
    state.previousFocusEl = document.activeElement;

    setModalOpen(state, true);
    refreshSummaryFromLiveCart(state);
    if (!state.saved) {
      if (state.formEl) show(state.formEl);
      hide(state.successEl);
      setStatus(state, 'modal', '', '');
      clearEmailError(state);
    }
    focusTarget = state.emailEl || q('.psm-panel', state.modalEl) || state.modalEl;
    if (window.trapFocus && typeof window.trapFocus === 'function') {
      try {
        window.trapFocus(state.modalEl, focusTarget);
      } catch (_e) {}
    }
    if (focusTarget && focusTarget.focus) {
      try {
        focusTarget.focus();
      } catch (_e2) {}
    }
    emitSaveCartEvent(state, 'ps:save-cart:opened', {
      modal_open: true
    });
  }

  function closeModal(state, meta){
    var wasOpen = false;
    var context = getActiveContext(state);
    var reason = trim(meta && meta.reason) || 'programmatic';
    var restoreFocusEl = null;

    if (!state || !state.modalEl) return;
    wasOpen = isModalVisible(state.modalEl);
    setModalOpen(state, false);
    if (!state.saved) {
      setStatus(state, 'modal', '', '');
      clearEmailError(state);
    }
    if (window.removeTrapFocus && typeof window.removeTrapFocus === 'function') {
      restoreFocusEl = state.previousFocusEl && document.contains(state.previousFocusEl) ? state.previousFocusEl : state.toggleEl;
      try {
        window.removeTrapFocus(restoreFocusEl || null);
      } catch (_e) {}
    } else {
      restoreFocusEl = state.previousFocusEl && document.contains(state.previousFocusEl) ? state.previousFocusEl : state.toggleEl;
      if (restoreFocusEl && restoreFocusEl.focus) {
        try {
          restoreFocusEl.focus();
        } catch (_e2) {}
      }
    }
    state.previousFocusEl = null;
    state.activeModalContext = null;
    if (wasOpen) {
      emitSaveCartEvent(state, 'ps:save-cart:closed', {
        modal_open: false,
        dismiss_reason: reason,
        source: context.source,
        variant_id: context.variant_id,
        trigger_type: context.trigger_type
      });
    }
  }

  function mountModalToBody(state){
    if (!state || !document.body) return;

    if (state.modalEl && state.modalEl.parentNode !== document.body) {
      try {
        document.body.appendChild(state.modalEl);
      } catch (_e) {}
    }

    if (state.restoreModalEl && state.restoreModalEl.parentNode !== document.body) {
      try {
        document.body.appendChild(state.restoreModalEl);
      } catch (_e) {}
    }
  }

  function getCurrentCart(cb){
    getJson(getCartJsUrl(), function(status, data){
      if (!(status >= 200 && status < 300) || !data) {
        cb(new Error('cart'), null);
        return;
      }
      cb(null, normalizeCartResponse(data));
    });
  }

  function syncRootCartAttributes(state, cart){
    var itemCount = 0;
    var totalPrice = 0;
    var currency = '';

    if (!state || !state.root || !cart) return;
    itemCount = parseInt(cart.item_count, 10) || 0;
    totalPrice = parseInt(cart.total_price, 10) || 0;
    currency = trim(cart.currency);
    state.root.setAttribute('data-ps-save-cart-count', String(itemCount));
    state.root.setAttribute('data-ps-save-cart-total', String(totalPrice));
    if (currency) state.root.setAttribute('data-ps-save-cart-currency', currency);
  }

  function refreshSummaryFromLiveCart(state){
    if (!state) return;

    if (state.latestCart) {
      syncRootCartAttributes(state, state.latestCart);
      updateSummary(state, state.latestCart);
    } else if (state.summaryCart) {
      updateSummary(state, state.summaryCart);
    }

    getCurrentCart(function(err, cart){
      if (err || !cart) return;
      state.latestCart = cart;
      syncRootCartAttributes(state, cart);
      updateSummary(state, cart);
    });
  }

  function saveCart(state, options){
    var email = '';
    var scope = '';
    var source = '';
    var variantId = '';
    var triggerType = '';
    var modalContext = null;
    var sourcePageType = '';
    options = options || {};
    email = trim(options.email);
    scope = options.scope === 'page' ? 'page' : 'modal';
    source = trim(options.source).toLowerCase();
    variantId = trim(options.variant_id);
    triggerType = trim(options.trigger_type);
    modalContext = scope === 'modal' ? getActiveContext(state) : normalizeModalContext(options);
    sourcePageType = normalizeSourcePageType(options.source_page_type, modalContext.source_page_type || getStatePageType(state));
    if (!hasValue(email)) email = trim(state.emailEl && state.emailEl.value);
    if (!source && scope === 'modal') source = modalContext.source;
    if (!source) source = 'manual';
    if (!variantId && scope === 'modal') variantId = modalContext.variant_id;
    if (!triggerType && scope === 'modal') triggerType = modalContext.trigger_type;

    if (state.saving) return;
    clearEmailError(state);
    setStatus(state, 'modal', '', '');
    setStatus(state, 'page', '', '');
    setTooltipVisibility(state, false);
    if (!isValidEmail(email)) {
      setEmailError(state, 'Enter a valid email address.');
      setStatus(state, 'modal', 'error', 'Enter a valid email address to save this cart.');
      if (state.emailEl && state.emailEl.focus) state.emailEl.focus();
      return;
    }

    state.saving = true;
    setLoading(state, scope, true);
    emitSaveCartEvent(state, 'ps:save-cart:submit-started', {
      source: source,
      variant_id: variantId,
      trigger_type: triggerType,
      submit_scope: scope
    });

    getCurrentCart(function(err, cart){
      var payload = null;
      var message = '';

      state.latestCart = cart || state.latestCart || null;

      if (err || !cart) {
        state.saving = false;
        setLoading(state, scope, false);
        message = 'We could not read your cart right now. Please try again.';
        if (scope === 'page') setStatus(state, 'page', 'error', message);
        else setStatus(state, 'modal', 'error', message);
        emitSaveCartEvent(state, 'ps:save-cart:submit-failed', {
          source: source,
          variant_id: variantId,
          trigger_type: triggerType,
          submit_scope: scope,
          message: message
        });
        return;
      }

      payload = {
        email: email,
        event_type: 'save_cart',
        source_page_type: sourcePageType,
        page_url: String(window.location && window.location.href ? window.location.href : ''),
        cart_token: cart.token || '',
        cart: cart
      };

      postJson(getSaveEndpoint(), payload, function(status, data){
        state.saving = false;
        setLoading(state, scope, false);

        if (status >= 200 && status < 300 && data && data.status !== 'error' && data.success !== false) {
          message = normalizeSuccessCopy(data && data.message);
          if (state.formEl) hide(state.formEl);
          if (state.successCopyEl) setText(state.successCopyEl, message);
          if (state.successEl) show(state.successEl);
          closeModal(state, { reason: 'submit_success' });
          applySavedState(state, email, {
            showTooltip: true
          });
          emitSaveCartEvent(state, 'ps:save-cart:submit-succeeded', {
            source: source,
            variant_id: variantId,
            trigger_type: triggerType,
            submit_scope: scope,
            message: message,
            cart_token: cart.token || '',
            item_count: parseInt(cart.item_count, 10) || 0,
            total_price: parseInt(cart.total_price, 10) || 0,
            currency: cart.currency || ''
          });
          return;
        }

        message = (data && (data.message || data.error)) ? String(data.message || data.error) : 'We could not save this cart right now. Please try again.';
        if (scope === 'page') setStatus(state, 'page', 'error', message);
        else setStatus(state, 'modal', 'error', message);
        emitSaveCartEvent(state, 'ps:save-cart:submit-failed', {
          source: source,
          variant_id: variantId,
          trigger_type: triggerType,
          submit_scope: scope,
          message: message,
          cart_token: cart.token || '',
          item_count: parseInt(cart.item_count, 10) || 0,
          total_price: parseInt(cart.total_price, 10) || 0,
          currency: cart.currency || ''
        });
      });
    });
  }

  function normalizeRestoreItem(item){
    var out = {};
    var id = 0;
    var quantity = 1;

    if (!item || typeof item !== 'object') return null;
    id = item.id != null ? item.id : item.variant_id;
    if (!id) return null;

    quantity = parseInt(item.quantity, 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;

    out.id = id;
    out.quantity = quantity;
    if (item.selling_plan != null && item.selling_plan !== '') out.selling_plan = item.selling_plan;
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) {
      out.selling_plan = item.selling_plan_allocation.selling_plan.id;
    }
    out.properties = cloneProperties(item.properties);
    return out;
  }

  function normalizeRestoreItems(items){
    var out = [];
    var normalized = null;
    var i = 0;

    if (!items || !items.length) return out;
    for (i = 0; i < items.length; i++) {
      normalized = normalizeRestoreItem(items[i]);
      if (normalized) out.push(normalized);
    }
    return out;
  }

  function getAuthoritativeCart(cb){
    getJson(getCartJsUrl(), function(status, data){
      if (!(status >= 200 && status < 300) || !data || !data.items) {
        cb(new Error('cart'), null);
        return;
      }
      cb(null, data);
    });
  }

  function sanitizeRestoredCartProperties(state, cb){
    function findContaminatedItem(cart){
      var index = 0;
      var item = null;
      var properties = null;
      for (index = 0; index < cart.items.length; index += 1) {
        item = cart.items[index] || {};
        properties = cloneCartProperties(item);
        if (JSON.stringify(item.properties || {}) !== JSON.stringify(properties)) {
          return { item: item, properties: properties };
        }
      }
      return null;
    }

    function replaceItemWithoutProperties(item, properties, done){
      var variantId = item.variant_id || item.id;
      var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.id : item.selling_plan;
      var addItem = { id: variantId, quantity: item.quantity || 1, properties: properties };
      if (!variantId || !item.key) {
        done(new Error('restore-property-key'));
        return;
      }
      if (sellingPlan) addItem.selling_plan = sellingPlan;
      postJson(getCartBaseUrl() + '/change.js', { id: item.key, quantity: 0 }, function(removeStatus){
        if (!(removeStatus >= 200 && removeStatus < 300)) {
          done(new Error('restore-property-remove'));
          return;
        }
        postJson(getCartAddUrl(), { items: [addItem] }, function(addStatus){
          if (!(addStatus >= 200 && addStatus < 300)) {
            done(new Error('restore-property-readd'));
            return;
          }
          done(null);
        });
      });
    }

    function sanitizeNext(previousSignature){
      getAuthoritativeCart(function(err, cart){
        var dirty = null;
        var payload = null;
        var signature = '';
        if (err || !cart || !cart.items) {
          cb(new Error('restore-property-read'));
          return;
        }
        dirty = findContaminatedItem(cart);
        if (!dirty) {
          cb(null);
          return;
        }
        signature = String(dirty.item.key || '') + '|' + JSON.stringify(dirty.item.properties || {});
        if (signature === previousSignature) {
          cb(new Error('restore-property-verify'));
          return;
        }
        setRestoreModalMessage(state, 'Cleaning restored cart details...');
        if (!Object.keys(dirty.properties).length) {
          replaceItemWithoutProperties(dirty.item, dirty.properties, function(replaceErr){
            if (replaceErr) {
              cb(replaceErr);
              return;
            }
            sanitizeNext(signature);
          });
          return;
        }
        if (!dirty.item.key) {
          cb(new Error('restore-property-key'));
          return;
        }
        payload = { id: dirty.item.key, quantity: dirty.item.quantity || 1, properties: dirty.properties };
        postJson(getCartBaseUrl() + '/change.js', payload, function(status){
          if (!(status >= 200 && status < 300)) {
            cb(new Error('restore-property-cleanup'));
            return;
          }
          sanitizeNext(signature);
        });
      });
    }

    sanitizeNext('');
  }

  function restoreCartItems(state, items, progressLabel, cb){
    var restoreItems = normalizeRestoreItems(items);
    var batchSize = 20;
    var total = restoreItems.length;

    if (typeof progressLabel === 'function') {
      cb = progressLabel;
      progressLabel = '';
    }
    progressLabel = hasValue(progressLabel) ? progressLabel : 'Restoring saved cart items';

    function addBatch(offset){
      var nextOffset = 0;
      var payload = null;

      if (offset >= total) {
        cb(null);
        return;
      }

      nextOffset = offset + batchSize;
      if (nextOffset > total) nextOffset = total;
      payload = { items: restoreItems.slice(offset, nextOffset) };
      setRestoreModalMessage(state, progressLabel + ' (' + nextOffset + ' of ' + total + ')...');
      postJson(getCartAddUrl(), payload, function(status, data){
        if (!(status >= 200 && status < 300)) {
          cb(new Error('add'));
          return;
        }
        addBatch(nextOffset);
      });
    }

    if (!total) {
      cb(null);
      return;
    }

    addBatch(0);
  }

  function rollbackCartSnapshot(state, snapshot, cb){
    var note = snapshot ? snapshot.note || '' : '';
    var attributes = snapshot && snapshot.attributes && typeof snapshot.attributes === 'object' ? cloneProperties(snapshot.attributes) : {};

    if (!snapshot) {
      cb(new Error('rollback'));
      return;
    }

    setRestoreModalMessage(state, 'Restoring your previous cart...');
    postJson(getCartClearUrl(), {}, function(clearStatus){
      if (!(clearStatus >= 200 && clearStatus < 300)) {
        cb(new Error('rollback-clear'));
        return;
      }

      restoreCartItems(state, snapshot.items || [], 'Restoring your previous cart items', function(err){
        if (err) {
          cb(err);
          return;
        }

        setRestoreModalMessage(state, 'Restoring your previous cart details...');
        postJson(getCartUpdateUrl(), { note: note, attributes: attributes }, function(updateStatus){
          if (!(updateStatus >= 200 && updateStatus < 300)) {
            cb(new Error('rollback-update'));
            return;
          }

          cb(null);
        });
      });
    });
  }

  function handleRestoreFailure(state, previousCart, message){
    var errorMessage = hasValue(message) ? message : 'We could not restore this cart right now. Please use the email link again or request a new one.';

    if (!state || !state.restoreMutatedCart || state.restoreRollingBack || !previousCart) {
      setRestoreError(state, errorMessage);
      return;
    }

    state.restoreRollingBack = true;
    rollbackCartSnapshot(state, previousCart, function(rollbackErr){
      state.restoreRollingBack = false;
      if (rollbackErr) {
        setRestoreError(state, 'We could not restore your previous cart completely. Your cart may not be complete. Please check your cart before checkout.');
        return;
      }
      setRestoreError(state, errorMessage);
    });
  }

  function setRestoreError(state, message){
    setRestoreModalError(state, message);
    setStatus(state, 'page', '', '');
    removeRestoreParamFromUrl();
    setLoading(state, 'page', false);
    state.restoring = false;
  }

  function finishRestore(state){
    var cleanUrl = buildUrlWithoutParam('ps_saved_cart');

    closeRestoreModal(state);
    setStatus(state, 'page', '', '');
    setLoading(state, 'page', false);
    state.restoring = false;
    try {
      window.location.replace(cleanUrl);
    } catch (_e) {
      window.location.href = cleanUrl;
    }
  }

  function getRestoreErrorMessage(status, data){
    var message = '';

    if (status === 404 || status === 410) {
      return 'This saved cart link is invalid or has expired. Please request a new cart email.';
    }

    if (data && (data.message || data.error)) message = String(data.message || data.error);
    if (hasValue(message)) return message;
    return 'We could not restore this cart right now. Please use the email link again or request a new one.';
  }

  function restoreCartSnapshot(state, snapshot){
    var items = snapshot && snapshot.cart && snapshot.cart.items ? snapshot.cart.items : [];
    var note = snapshot && snapshot.cart ? snapshot.cart.note || '' : '';
    var attributes = snapshot && snapshot.cart && snapshot.cart.attributes && typeof snapshot.cart.attributes === 'object' ? cloneProperties(snapshot.cart.attributes) : {};

    setRestoreModalMessage(state, 'Clearing your current cart...');
    postJson(getCartClearUrl(), {}, function(clearStatus){
      if (!(clearStatus >= 200 && clearStatus < 300)) {
        handleRestoreFailure(state, state.previousCartSnapshot, 'We could not clear the current cart. Please try again.');
        return;
      }
      state.restoreMutatedCart = true;

      restoreCartItems(state, items, function(err){
        if (err) {
          handleRestoreFailure(state, state.previousCartSnapshot, 'We could not restore every cart item. Please try again.');
          return;
        }

        sanitizeRestoredCartProperties(state, function(cleanupErr){
          if (cleanupErr) {
            handleRestoreFailure(state, state.previousCartSnapshot, 'We could not clean restored cart details. Please try again.');
            return;
          }

          setRestoreModalMessage(state, 'Finalizing your restored cart...');
          postJson(getCartUpdateUrl(), { note: note, attributes: attributes }, function(updateStatus){
            if (!(updateStatus >= 200 && updateStatus < 300)) {
              handleRestoreFailure(state, state.previousCartSnapshot, 'We could not restore your cart details. Please try again.');
              return;
            }

            finishRestore(state);
          });
        });
      });
    });
  }

  function startRestore(state){
    var token = trim(state && state.restoreToken);
    var restoreStatusOk = false;

    if (!token) return;
    if (restoreRunTokens[token]) return;
    restoreRunTokens[token] = true;
    if (state.restoring) return;

    state.restoring = true;
    state.restoreMutatedCart = false;
    state.restoreRollingBack = false;
    setStatus(state, 'page', '', '');
    openRestoreModal(state, 'Restoring your saved cart. Please wait...');

    getJson(getLookupEndpoint(token), function(status, data){
      restoreStatusOk = status >= 200 && status < 300 && data && data.cart && data.success !== false && data.status !== 'error';
      if (!restoreStatusOk) {
        setRestoreError(state, getRestoreErrorMessage(status, data));
        return;
      }

      setRestoreModalMessage(state, 'Preparing your saved cart...');
      getAuthoritativeCart(function(cartStatusErr, currentCart){
        if (cartStatusErr || !currentCart) {
          setRestoreError(state, 'We could not read your current cart. Please try again.');
          return;
        }

        state.previousCartSnapshot = currentCart;
        restoreCartSnapshot(state, data);
      });
    });
  }

  function registerSaveCartState(state){
    var i = 0;
    if (!state) return;
    for (i = 0; i < saveCartStates.length; i++) {
      if (saveCartStates[i] === state) return;
    }
    saveCartStates.push(state);
  }

  function unregisterRemovedStates(){
    var next = [];
    var i = 0;
    for (i = 0; i < saveCartStates.length; i++) {
      if (saveCartStates[i] && saveCartStates[i].root && document.contains(saveCartStates[i].root)) next.push(saveCartStates[i]);
    }
    saveCartStates = next;
  }

  function getPrimaryState(){
    unregisterRemovedStates();
    return saveCartStates.length ? saveCartStates[0] : null;
  }

  function isAnySaveCartModalOpen(){
    var i = 0;
    unregisterRemovedStates();
    for (i = 0; i < saveCartStates.length; i++) {
      if (isModalVisible(saveCartStates[i] && saveCartStates[i].modalEl)) return true;
    }
    return false;
  }

  function openSaveCartFromExternal(options){
    var state = getPrimaryState();
    var context = options && typeof options === 'object' ? options : {};
    var normalizedContext = normalizeModalContext(context);
    var canOpen = false;

    if (!state || !state.modalEl || !state.formEl || !state.emailEl || !state.submitEl) return false;
    if (state.saving || state.restoring) return false;
    if (isModalVisible(state.modalEl)) return true;

    canOpen = !!context.force || !state.saved;
    if (!canOpen) return false;
    if (normalizedContext.source !== 'exit_intent') normalizedContext.source = 'manual';
    normalizedContext.variant_id = trim(context.variant_id || normalizedContext.variant_id);
    normalizedContext.trigger_type = trim(context.trigger_type || normalizedContext.trigger_type);
    normalizedContext.offer_id = trim(context.offer_id || normalizedContext.offer_id || normalizedContext.variant_id || 'cart-save');
    normalizedContext.source_page_type = normalizeSourcePageType(context.source_page_type, normalizedContext.source_page_type || getStatePageType(state));
    normalizedContext.source_surface = trim(context.source_surface || normalizedContext.source_surface || getStateSurface(state, normalizedContext.source_page_type)).toLowerCase();
    normalizedContext.device_type = trim(context.device_type || normalizedContext.device_type || getDeviceType()).toLowerCase();
    normalizedContext.winner_reason = trim(context.winner_reason || normalizedContext.winner_reason);
    normalizedContext.confidence_reasons = trim(context.confidence_reasons || normalizedContext.confidence_reasons);
    normalizedContext.cart_signature = trim(context.cart_signature || normalizedContext.cart_signature);
    openModal(state, normalizedContext);
    return true;
  }

  function exposeSaveCartApi(){
    PS.SaveCart = PS.SaveCart || {};
    PS.SaveCart.open = openSaveCartFromExternal;
    PS.SaveCart.isModalOpen = isAnySaveCartModalOpen;
    PS.SaveCart.getState = getPrimaryState;
  }

  function bindRoot(root){
    var state = {
      root: root,
      saving: false,
      saved: false,
      restoring: false,
      restoreMutatedCart: false,
      restoreRollingBack: false,
      previousCartSnapshot: null,
      savedEmail: '',
      tooltipDismissTimer: 0,
      activeModalContext: null,
      previousFocusEl: null,
      latestCart: null,
      customerEmail: trim(root.getAttribute('data-ps-save-cart-customer-email')),
      restoreToken: trim(getQueryParam('ps_saved_cart'))
    };

    state.cartItemsEl = closestTag(root, 'cart-items') || document.querySelector('cart-items');
    state.footerEl = document.getElementById('main-cart-footer');
    state.toggleEl = q('[data-ps-save-cart-toggle]', root);
    state.modalEl = q('[data-ps-save-cart-modal]', root);
    state.backdropEl = q('[data-ps-save-cart-backdrop]', root);
    state.closeEl = q('[data-ps-save-cart-close]', root);
    state.formEl = q('[data-ps-save-cart-form]', root);
    state.emailEl = q('[data-ps-save-cart-email]', root);
    state.emailErrorEl = q('[data-ps-save-cart-email-error]', root);
    state.submitEl = q('[data-ps-save-cart-submit]', root);
    state.pageStatusEl = q('[data-ps-save-cart-status]', root);
    state.modalStatusEl = q('[data-ps-save-cart-modal-status]', root);
    state.restoreModalEl = q('[data-ps-save-cart-restore-modal]', root) || q('[data-ps-save-cart-restore-modal]');
    state.restoreModalMessageEl = q('[data-ps-save-cart-restore-modal-message]', root) || q('[data-ps-save-cart-restore-modal-message]');
    state.restoreModalProgressEl = q('[data-ps-save-cart-restore-modal-progress]', root) || q('[data-ps-save-cart-restore-modal-progress]');
    state.restoreModalErrorEl = q('[data-ps-save-cart-restore-modal-error]', root) || q('[data-ps-save-cart-restore-modal-error]');
    state.restoreModalActionsEl = q('[data-ps-save-cart-restore-modal-actions]', root) || q('[data-ps-save-cart-restore-modal-actions]');
    state.restoreModalCloseEl = q('[data-ps-save-cart-restore-modal-close]', root) || q('[data-ps-save-cart-restore-modal-close]');
    state.toggleLabelEl = q('[data-ps-save-cart-toggle-label]', root);
    state.tooltipEl = q('[data-ps-save-cart-tooltip]', root);
    state.tooltipCloseEl = q('[data-ps-save-cart-tooltip-close]', root);
    state.tooltipEmailEl = q('[data-ps-save-cart-tooltip-email]', root);
    state.successEl = q('[data-ps-save-cart-success]', root);
    state.successCopyEl = q('[data-ps-save-cart-success-copy]', root);
    state.summaryEl = q('[data-ps-save-cart-summary]', root);
    state.summaryPaintEl = q('[data-ps-save-cart-summary-paint]', root);
    state.summaryPaintListEl = q('[data-ps-save-cart-summary-paint-list]', root);
    state.summaryCodeEl = q('[data-ps-save-cart-summary-code]', root);
    state.summaryGalleryEl = q('[data-ps-save-cart-summary-gallery]', root);
    state.summaryThumbsEl = q('[data-ps-save-cart-summary-thumbs]', root);
    state.summaryOverflowEl = q('[data-ps-save-cart-summary-overflow]', root);

    if (!state.toggleEl || !state.modalEl || !state.formEl || !state.emailEl || !state.submitEl) {
      root.style.display = 'none';
      return;
    }

    registerSaveCartState(state);

    state.toggleDefaultLabel = trim((state.toggleLabelEl && state.toggleLabelEl.textContent) || state.toggleEl.textContent || 'Save Cart');
    state.toggleEl.setAttribute('data-ps-save-cart-label', state.toggleDefaultLabel || 'Save Cart');
    state.submitEl.setAttribute('data-ps-save-cart-label', state.submitEl.textContent || 'Email me this cart');
    if (!hasValue(state.emailEl.value) && isValidEmail(state.customerEmail)) state.emailEl.value = state.customerEmail;
    mountModalToBody(state);
    hide(state.successEl);
    hide(state.pageStatusEl);
    hide(state.modalStatusEl);
    dismissTooltip(state);
    hide(state.restoreModalErrorEl);
    hide(state.restoreModalActionsEl);
    setRestorePageActive(state, !!state.restoreToken);
    if (state.restoreToken) openRestoreModal(state, 'Restoring your saved cart. Please wait...');
    else closeRestoreModal(state);
    hide(state.emailErrorEl);

    updateSummary(state, {
      item_count: parseInt(root.getAttribute('data-ps-save-cart-count'), 10) || 0,
      total_price: parseInt(root.getAttribute('data-ps-save-cart-total'), 10) || 0,
      currency: root.getAttribute('data-ps-save-cart-currency') || 'USD'
    });
    refreshSummaryFromLiveCart(state);

    state.toggleEl.addEventListener('click', function(){
      var email = '';
      if (state.toggleEl.disabled || state.saving || state.restoring) return;
      email = getPreferredEmail(state);
      if (isValidEmail(email)) {
        saveCart(state, { scope: 'page', email: email, source: 'manual', trigger_type: 'manual_click' });
        return;
      }
      openModal(state, { source: 'manual', trigger_type: 'manual_click' });
    });

    state.tooltipCloseEl && state.tooltipCloseEl.addEventListener('click', function(){
      dismissTooltip(state);
    });

    if (window.addEventListener) {
      state.handleWindowResize = function(){
        positionTooltip(state);
        if (state.summaryCart) updateSummary(state, state.summaryCart);
      };
      window.addEventListener('resize', state.handleWindowResize);
    }

    state.closeEl && state.closeEl.addEventListener('click', function(){
      if (state.saving) return;
      closeModal(state, { reason: 'x' });
    });

    state.backdropEl && state.backdropEl.addEventListener('click', function(){
      if (state.saving) return;
      closeModal(state, { reason: 'backdrop' });
    });

    state.modalEl.addEventListener('click', function(evt){
      if (state.saving) return;
      if (evt && evt.target === state.modalEl) closeModal(state, { reason: 'backdrop' });
    });

    state.modalEl.addEventListener('keydown', function(evt){
      var key = evt && (evt.key || evt.keyCode);
      if (state.saving) return;
      if (key === 'Escape' || key === 27) closeModal(state, { reason: 'escape' });
    });

    state.emailEl.addEventListener('input', function(){
      clearEmailError(state);
    });

    state.formEl.addEventListener('submit', function(evt){
      var context = getActiveContext(state);
      if (evt && evt.preventDefault) evt.preventDefault();
      saveCart(state, {
        scope: 'modal',
        source: context.source,
        variant_id: context.variant_id,
        trigger_type: context.trigger_type
      });
    });

    state.restoreModalCloseEl && state.restoreModalCloseEl.addEventListener('click', function(){
      if (state.restoring) return;
      closeRestoreModal(state);
      setRestorePageActive(state, false);
      removeRestoreParamFromUrl();
      setStatus(state, 'page', '', '');
    });

    startRestore(state);
  }

  function init(){
    var roots = document.querySelectorAll('[data-ps-save-cart]');
    var i = 0;

    exposeSaveCartApi();
    for (i = 0; i < roots.length; i++) {
      bindRoot(roots[i]);
    }
  }

  onReady(init);
})(window, document);
